import * as Sentry from '@sentry/browser';
import { InstallmentEditable } from 'components/registration/v2/types';
import { parseErrorMessage, SENTRY_TAGS_PRE } from 'core/error-utils';

import api, { Response } from 'core/api';
import { PendingEdit } from './types';

export async function getEditableQuestions<T>(
  formResultId: number
): Promise<Response<T>> {
  try {
    return await api.get<T>(`/form_results/${formResultId}/editable_questions`);
  } catch (e) {
    Sentry.captureException(e, {
      extra: { formResultId },
      tags: SENTRY_TAGS_PRE,
    });
    throw new Error(parseErrorMessage(e, 'Failed to retrieve data'));
  }
}

export async function getPreviewLineItems<T>(
  formResultId: number,
  orderId: number,
  pendingEdits: PendingEdit[]
): Promise<Response<T>> {
  try {
    return await api.post(`/form_results/${formResultId}/preview_line_items`, {
      orderId,
      pendingEdits,
    });
  } catch (e) {
    Sentry.captureException(e, {
      extra: { formResultId, pendingEdits },
      tags: SENTRY_TAGS_PRE,
    });
    throw new Error(parseErrorMessage(e, 'Failed to retrieve data'));
  }
}

export async function saveAllEdits<T>(
  formResultId: number,
  orderId: number,
  pendingEdits: PendingEdit[],
  installments?: Partial<InstallmentEditable>[]
): Promise<Response<T>> {
  try {
    return await api.post(`/form_results/${formResultId}/save_pending_edits`, {
      orderId,
      pendingEdits,
      installments,
    });
  } catch (e) {
    Sentry.captureException(e, {
      extra: { formResultId, pendingEdits, installments },
      tags: SENTRY_TAGS_PRE,
    });
    throw new Error(parseErrorMessage(e, 'Failed to save edits'));
  }
}
